export default __webpack_public_path__ + "static/media/fc.00e6db53.jpg";